import { useRef, useMemo } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";

import useUiuxStore from "src/store/useUiuxStore";

import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_PRD3011_R01 } from "./Content_PRD3011_R01";
import { Info_PRD3011_R01 } from "./Info_PRD3011_R01";
import { SearchSection_PRD3011_R01 } from "./SearchSection_PRD3011_R01";
import { usePRD3011_R01Store } from "./Store_PRD3011_R01";
import { AgGridReact } from "ag-grid-react";
import { PRD3011_R01DowntimeDto, PRD3011_R01HeaderDto, PRD3011_R01InspectDto, PRD3011_R01DetailDto } from "./Dto_PRD3011_R01";
import { Table_PRD3011_R01 } from "./Table_PRD3011_R01";
import { DetailTable_PRD3011_R01 } from "./DetailTable_PRD3011_R01";
import { Modal_PRD3011_R01 } from "./Modal_PRD3011_R01";

export const Container_PRD3011_R01 = () => {

	const { syncInitialData } = usePRD3011_R01Store();

	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'PRD3011_R01',
		type: 'width',
		storageKey: 'PRD3011_R01-split-width',
		min: 5,
		max: 80,
		default: 40
	} as const;

	const V_RESIZER = {
		code: 'PRD3011_R01',
		type: 'height',
		storageKey: 'PRD3011_R01-info-split-height',
		min: 5,
		max: 80,
		default: 60
	} as const;

	const gridRef = useRef<AgGridReact<PRD3011_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<PRD3011_R01DetailDto>>(null);
	const inspectGridRef = useRef<AgGridReact<PRD3011_R01InspectDto>>(null);
	const downtimeGridRef = useRef<AgGridReact<PRD3011_R01DowntimeDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const rightTopRef = useRef<HTMLDivElement>(null);

	const isResizing = useRef(false);
	const isVResizing = useRef(false);

	const { 
		splitValue,
		handleMouseDown,
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	const {
		handlePrintClick,
		handleExcelClick,
		fetchData,	
		defaultPRD3011_R01HeaderRow,
		defaultPRD3011_R01DetailRow,
		defaultPRD3011_R01InspectRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleFetchBomProductList,
		handleFetchDetailData,
	} = Content_PRD3011_R01({
		gridRef,
		detailGridRef,
		inspectGridRef,
		downtimeGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	});

	useMemo(() => { syncInitialData(); }, []);

	const headerDefaultRow = useMemo(() => defaultPRD3011_R01HeaderRow(), [defaultPRD3011_R01HeaderRow]);
	const detailDefaultRow = useMemo(() => defaultPRD3011_R01DetailRow(), [defaultPRD3011_R01DetailRow]);
	const inspectDefaultRow = useMemo(() => defaultPRD3011_R01InspectRow(), [defaultPRD3011_R01InspectRow]);

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={handlePrintClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_PRD3011_R01 onEnterKeyDown={() => { fetchData(); }} />
		<Modal_PRD3011_R01  
			defaultPRD3011_R01HeaderRow={headerDefaultRow}
			inspectGridRef={inspectGridRef}
			defaultPRD3011_R01InspectRow={inspectDefaultRow}
			handleDeleteClick={handleDeleteClick}
		/>
		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_PRD3011_R01 gridRef={gridRef} handleCreateClick={handleCreateClick} defaultPRD3011_R01HeaderRow={headerDefaultRow} />
			</div>
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<div className="w-full max-w-full flex flex-1" style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
					<Info_PRD3011_R01 editable={false} 
						defaultPRD3011_R01HeaderRow={headerDefaultRow}
						handleFetchBomProductList={handleFetchBomProductList}
						handleFetchDetailData={handleFetchDetailData} />
				</div>
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
				/>
				<div style={{ height: `${100 - vSplitValue}%` }}>
					<DetailTable_PRD3011_R01 gridRef={detailGridRef} defaultPRD3011_R01DetailRow={detailDefaultRow} />
				</div>
			</div>
		</div>
		<Message />
	</div>
}
